import { motion } from "framer-motion";
import { WHATSAPP } from "../../data/content";
import { Logo } from "./Logo";
import { CtaButton, Reveal } from "./Primitives";
import { scrollToId } from "./Nav";

export const FinalCta = () => (
  <section data-testid="final-cta-section" className="px-3 pb-3 sm:px-6">
    <div className="cta-panel relative mx-auto max-w-[1400px] overflow-hidden rounded-[36px] bg-ink px-6 py-24 text-paper sm:px-12 lg:py-36">
      <div className="relative mx-auto max-w-4xl text-center">
        <Reveal>
          <p className="text-[13px] font-semibold uppercase tracking-[0.24em] text-cobalt-200">Ready to build a pipeline?</p>
          <h2 className="mt-6 font-display text-4xl font-bold leading-[1.02] tracking-[-0.035em] sm:text-6xl lg:text-7xl">Your next best client should not be <span className="font-serif font-normal italic text-cobalt-200">left to chance.</span></h2>
          <p className="mx-auto mt-8 max-w-xl text-base text-paper/75 sm:text-lg">Let's identify the fastest path to qualified conversations in your market.</p>
          <div className="mt-12 flex flex-wrap items-center justify-center gap-4">
            <CtaButton testId="final-cta-button" variant="light">Build my sales pipeline</CtaButton>
            <a href={WHATSAPP} target="_blank" rel="noopener noreferrer" data-testid="final-whatsapp-link" className="rounded-full border border-paper/25 px-6 py-3.5 text-[15px] font-semibold text-paper transition-colors hover:bg-paper hover:text-ink">Message on WhatsApp</a>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);

export const Footer = () => (
  <footer data-testid="footer" className="mx-auto max-w-7xl px-5 py-12 sm:px-8">
    <div className="flex flex-col items-start justify-between gap-8 md:flex-row md:items-center">
      <Logo />
      <nav className="flex flex-wrap gap-x-6 gap-y-2 text-[14px] text-ink/70">
        {[["Results", "results"], ["System", "system"], ["Founder", "founder"], ["Pricing", "pricing"], ["FAQ", "faq"]].map(([l, id]) => (
          <button key={id} data-testid={`footer-link-${id}`} onClick={() => scrollToId(id)} className="hover:text-ink">{l}</button>
        ))}
      </nav>
      <p className="text-[13px] text-ink/60">© 2026 COENZIO. All rights reserved.</p>
    </div>
  </footer>
);

export const WhatsAppFab = () => (
  <motion.a
    href={WHATSAPP}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="floating-whatsapp-btn"
    aria-label="Open WhatsApp"
    initial={{ scale: 0, opacity: 0 }}
    animate={{ scale: 1, opacity: 1 }}
    transition={{ delay: 1.8, type: "spring", stiffness: 260, damping: 20 }}
    whileHover={{ scale: 1.08 }}
    className="fixed bottom-5 right-5 z-50 grid h-14 w-14 place-items-center rounded-full bg-[#25D366] text-white shadow-[0_14px_30px_-10px_rgba(37,211,102,0.8)]"
  >
    <svg viewBox="0 0 24 24" className="h-7 w-7" fill="currentColor"><path d="M17.47 14.38c-.3-.15-1.75-.86-2.02-.96-.27-.1-.47-.15-.67.15-.2.3-.77.96-.94 1.16-.17.2-.35.22-.64.07-.3-.15-1.25-.46-2.38-1.47-.88-.79-1.47-1.76-1.65-2.06-.17-.3-.02-.46.13-.6.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.03-.52-.07-.15-.67-1.6-.92-2.2-.24-.58-.49-.5-.67-.5h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48s1.07 2.88 1.21 3.08c.15.2 2.1 3.2 5.08 4.49.71.31 1.26.49 1.7.63.71.22 1.36.19 1.87.12.57-.09 1.75-.72 2-1.41.25-.69.25-1.29.17-1.41-.07-.13-.27-.2-.57-.35M12.05 21.5h-.01a9.4 9.4 0 0 1-4.8-1.32l-.34-.2-3.57.94.95-3.48-.22-.36a9.4 9.4 0 0 1-1.45-5.03c0-5.2 4.24-9.44 9.45-9.44a9.4 9.4 0 0 1 9.44 9.45c0 5.2-4.24 9.44-9.45 9.44m8.04-17.48A11.3 11.3 0 0 0 12.05.7C5.78.7.68 5.8.68 12.06c0 2 .52 3.96 1.52 5.68L.6 23.6l6.01-1.58a11.3 11.3 0 0 0 5.43 1.38h.01c6.26 0 11.36-5.1 11.37-11.36 0-3.04-1.18-5.89-3.33-8.03" /></svg>
  </motion.a>
);
